/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { Button, ButtonToolbar } from "react-bootstrap";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openReceiptDialog, openDeleteDialog, openEditDialog }
) => (
  <>
    <ButtonToolbar className="view-download-btn justify-content-end">
      <Button
        variant="btn btn-icon btn-light-primary btn-sm mx-1 font-size-sm"
        onClick={() => {
          openEditDialog(row);
        }}
      >
        <i className="fa fa-edit" />
      </Button>
      <Button
        variant="btn btn-icon btn-light-danger btn-sm mx-1 font-size-sm"
        onClick={() => {
          openDeleteDialog(row);
      }}
      >
        <i className="fas fa-trash-alt"></i>
      </Button>
    </ButtonToolbar>
    <> </>
  </>
);
